/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SystemMessageLevel } from './systemMessageLevel';
import type { SystemMessageButtonLabel } from './systemMessageButtonLabel';
import type { SystemMessageButtonLink } from './systemMessageButtonLink';

/**
 * System message that can be displayed to users
 */
export interface SystemMessage {
  message: string;
  displayFrom: string;
  displayTo: string;
  level?: SystemMessageLevel;
  buttonLabel?: SystemMessageButtonLabel;
  buttonLink?: SystemMessageButtonLink;
}
